import React from "react";
import PropTypes from "prop-types";
import {
  CardWrapper,
  Row,
  Column,
  Title,
  Text,
  CollapsibleLink,
} from "../shared/data-card/data-card-styles";

class CandidateDescription extends React.Component {
  constructor(props) {
    super(props);
    this.wrapperRef = React.createRef();
    this.contentRef = React.createRef();
    this.state = {
      isExpanded: false,
      wrapperHeigh: null,
      contentHeight: null,
    };
  }

  componentDidMount() {
    const wrapper = this.wrapperRef.current;
    const content = this.contentRef.current;

    this.setState({
      wrapperHeigh: wrapper.clientHeight,
      contentHeight: content.clientHeight,
    });
  }

  onCollapseClick = () => {
    this.setState(({ isExpanded }) => ({
      isExpanded: !isExpanded,
    }));
  };

  render() {
    const { candidateDescription, noMobile, noDesktop } = this.props;
    const { isExpanded, wrapperHeigh, contentHeight } = this.state;

    return (
      <CardWrapper
        marginTop
        marginBottom
        noMobile={noMobile}
        ref={this.wrapperRef}
        noDesktop={noDesktop}
      >
        <Row>
          <Column className={isExpanded ? "expanded" : ""} collapsibleType>
            <Title>Additional Information</Title>
            <Text
              dangerouslySetInnerHTML={{ __html: candidateDescription }}
              ref={this.contentRef}
            />
            {contentHeight + 110 > wrapperHeigh && (
              <CollapsibleLink onClick={this.onCollapseClick}>
                {isExpanded ? "show less" : "read more"}
              </CollapsibleLink>
            )}
          </Column>
        </Row>
      </CardWrapper>
    );
  }
}

CandidateDescription.propTypes = {
  candidateDescription: PropTypes.string.isRequired,
  noMobile: PropTypes.bool,
  noDesktop: PropTypes.bool,
};

CandidateDescription.defaultProps = {
  noMobile: PropTypes.bool.isNull,
  noDesktop: PropTypes.bool.isNull,
};

export default CandidateDescription;
